module.exports = __webpack_public_path__ + "assets/img/c21.c768a570.png";